import { ArrowIcon } from 'public/svg/IconsSvg';

type AnchorProps = {
    onClickHandler: () => void;
    text?: string | JSX.Element;
};

const Anchor: FC<AnchorProps> = ({ onClickHandler, text }) => {
    return (
        <div
            className="mr-2 flex h-8 cursor-pointer flex-row items-center justify-center whitespace-nowrap rounded-2xl bg-gray px-4 text-[13px] font-bold leading-4 tracking-wide hover:bg-grayMidDarker"
            onClick={onClickHandler}
        >
            {text}
            <ArrowIcon className="ml-2 h-2 w-2" />
        </div>
    );
};

export default Anchor;
